'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _actions = require('../actions.js');

var _actions2 = _interopRequireDefault(_actions);

var _localize = require('linksoft/utils/localize');

var _localize2 = _interopRequireDefault(_localize);

var _DispatchWarning = require('../components/DispatchWarning');

var _DispatchWarning2 = _interopRequireDefault(_DispatchWarning);

var _SendOrderButton = require('./SendOrderButton');

var _SendOrderButton2 = _interopRequireDefault(_SendOrderButton);

var _linksoftAlbatros = require('linksoft-albatros');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CartSummary = function (_Component) {
    (0, _inherits3.default)(CartSummary, _Component);

    function CartSummary() {
        (0, _classCallCheck3.default)(this, CartSummary);
        return (0, _possibleConstructorReturn3.default)(this, (CartSummary.__proto__ || (0, _getPrototypeOf2.default)(CartSummary)).apply(this, arguments));
    }

    (0, _createClass3.default)(CartSummary, [{
        key: 'render',
        value: function render() {
            var _props$cart = this.props.cart,
                totalVat = _props$cart.totalVat,
                _props$cart$totalPric = _props$cart.totalPrice,
                totalPrice = _props$cart$totalPric === undefined ? {} : _props$cart$totalPric,
                _props$cart$totalPric2 = _props$cart.totalPriceCommission,
                totalPriceCommission = _props$cart$totalPric2 === undefined ? {} : _props$cart$totalPric2,
                _props$cart$totalPric3 = _props$cart.totalPriceInvoice,
                totalPriceInvoice = _props$cart$totalPric3 === undefined ? {} : _props$cart$totalPric3;


            return _react2.default.createElement(
                'div',
                { className: 'cartMiniTable' },
                _react2.default.createElement(
                    'div',
                    { className: 'table-block', id: 'order-detail-content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'clearfix row' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-6 col-lg-12' },
                            _react2.default.createElement(
                                'table',
                                { id: 'cart-summary', className: 'table' },
                                totalPriceCommission.finalPrice > 0 ? _react2.default.createElement(
                                    'tbody',
                                    null,
                                    _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            { colSpan: '2', className: 'cart-table-title' },
                                            (0, _localize2.default)("App:OnCommission")
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'tr',
                                        { className: 'cart-total-price ' },
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            (0, _localize2.default)("App:TotalPriceWithoutVat")
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            { className: 'price' },
                                            (0, _linksoftAlbatros.formatPrice)(totalPriceCommission.finalPriceWithoutVat, _linksoftAlbatros.PriceType.CartTotalPriceWithoutVat)
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            (0, _localize2.default)("App:TotalPriceWithVat")
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            { className: 'price',
                                                id: 'total-price' },
                                            (0, _linksoftAlbatros.formatPrice)(totalPriceCommission.finalPrice, _linksoftAlbatros.PriceType.CartTotalPrice)
                                        )
                                    )
                                ) : null,
                                totalPriceInvoice.finalPrice > 0 ? _react2.default.createElement(
                                    'tbody',
                                    null,
                                    _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            { colSpan: '2', className: 'cart-table-title' },
                                            (0, _localize2.default)("App:OnInvoice")
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'tr',
                                        { className: 'cart-total-price ' },
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            (0, _localize2.default)("App:TotalPriceWithoutVat")
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            { className: 'price' },
                                            (0, _linksoftAlbatros.formatPrice)(totalPriceInvoice.finalPriceWithoutVat, _linksoftAlbatros.PriceType.CartTotalPriceWithoutVat)
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            (0, _localize2.default)("App:TotalPriceWithVat")
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            { className: 'price',
                                                id: 'total-price' },
                                            (0, _linksoftAlbatros.formatPrice)(totalPriceInvoice.finalPrice, _linksoftAlbatros.PriceType.CartTotalPrice)
                                        )
                                    )
                                ) : null,
                                _react2.default.createElement(
                                    'tbody',
                                    { className: 'total-rows' },
                                    _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            (0, _localize2.default)("App:TotalVat")
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            { className: 'price' },
                                            (0, _linksoftAlbatros.formatPrice)(totalVat, _linksoftAlbatros.PriceType.CartTotalPrice)
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'tr',
                                        null,
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            (0, _localize2.default)("App:TotalPriceWithVat")
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            { className: 'price price-green' },
                                            (0, _linksoftAlbatros.formatPrice)(totalPrice.finalPrice, _linksoftAlbatros.PriceType.CartTotalPrice)
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'table-sumary-info col-sm-6 col-lg-12' },
                            _react2.default.createElement(_DispatchWarning2.default, null)
                        )
                    )
                ),
                _react2.default.createElement(_SendOrderButton2.default, null)
            );
        }
    }]);
    return CartSummary;
}(_react.Component);

CartSummary.propTypes = {
    cart: _propTypes2.default.object.isRequired,
    saveOptions: _propTypes2.default.func.isRequired
};

function mapStateToProps(state, ownProps) {
    return {
        cart: state.cart
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
    saveOptions: _actions2.default.saveOptions
})(CartSummary);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/CartSummary.js
// module id = 902
// module chunks = 0